import { render, staticRenderFns } from "./KycGroup.vue?vue&type=template&id=142f140d"
import script from "./KycGroup.vue?vue&type=script&lang=js"
export * from "./KycGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports